module.exports = __webpack_public_path__ + "img/icon_over_manejo_formularios.d4d2c102.svg";